/* ==========================================================================
   Pre-cut line: locked quantity, all-or-nothing removal
   --------------------------------------------------------------------------
   The "Pre-cut Option" line is a derived charge — $0.19 x every DTF by-size
   piece submitted with pre-cut on (bysize-v4.js appends it at checkout). So:

     • its quantity is NOT editable in the cart (steppers/input removed —
       a shopper editing it would desync the charge from the transfers)
     • it IS removable, and removing it means the order is no longer pre-cut:
       we also strip properties.Precut from every remaining line so the
       production paperwork matches what was paid for.

   Runs on the cart page AND the drawer; both re-render, so the lock is
   re-applied from a MutationObserver and removal is caught in capture phase.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__precutCartLock) return;
  window.__precutCartLock = true;

  var PRECUT_RE = /\/products\/precut(\?|$)|pre-?cut option/i;

  function isPrecutRow(row) {
    if (!row) return false;
    var link = row.querySelector('a[href*="/products/precut"]');
    if (link) return true;
    var title = row.querySelector('.cart-item__title, [class*="item__title"]');
    return !!(title && /pre-?cut option/i.test(title.textContent || ''));
  }

  function rowsOf(scope) {
    return (scope || document).querySelectorAll('.cart-item__product-info, [class*="cart-item__product-info"]');
  }

  /* ---------- 1. lock the quantity UI ---------- */
  function lock(scope) {
    var rows = rowsOf(scope);
    for (var i = 0; i < rows.length; i++) {
      var row = rows[i];
      if (!isPrecutRow(row) || row.getAttribute('data-precut-locked')) continue;
      row.setAttribute('data-precut-locked', '1');

      var input = row.querySelector('input[name="updates[]"]');
      var qty = input ? input.value : '';

      /* kill the steppers so there is nothing to click */
      var btns = row.querySelectorAll('.qty-button, .qty-minus, .qty-plus');
      for (var b = 0; b < btns.length; b++) btns[b].style.display = 'none';

      if (input) {
        input.readOnly = true;
        input.tabIndex = -1;
        input.setAttribute('aria-readonly', 'true');
        input.style.pointerEvents = 'none';
        input.style.textAlign = 'center';
        input.style.width = '3.2em';
        input.style.border = '0';
        input.style.background = 'transparent';
        input.style.fontWeight = '700';
        /* keep the value posting so a cart-form submit can't zero it */
        input.value = qty;
      }
      /* explain the lock once, next to the count */
      var holder = input && input.parentElement;
      if (holder && !holder.querySelector('[data-precut-note]')) {
        holder.style.position = 'relative';
        var note = document.createElement('span');
        note.setAttribute('data-precut-note', '1');
        note.textContent = 'set by your order';
        /* absolute so it sits UNDER the pill instead of inside the flex row */
        note.style.cssText = 'position:absolute;top:100%;left:0;right:0;margin-top:4px;' +
          'font-size:11px;color:#8A94A6;font-weight:600;text-align:center;white-space:nowrap;';
        holder.appendChild(note);
      }
    }
  }

  /* ---------- 2. removal clears pre-cut from the whole order ---------- */
  var clearing = false;
  function clearPrecutFlags() {
    if (clearing) return;
    clearing = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var flagged = (cart.items || []).filter(function (it) {
          return it.properties && it.properties.Precut;
        });
        if (!flagged.length) { clearing = false; return; }
        /* change.js REPLACES properties, so resend each line's own set minus Precut */
        var chain = Promise.resolve();
        flagged.forEach(function (it) {
          chain = chain.then(function () {
            var props = {};
            Object.keys(it.properties || {}).forEach(function (k) {
              if (k !== 'Precut') props[k] = it.properties[k];
            });
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props })
            });
          });
        });
        return chain.then(function () {
          clearing = false;
          /* repaint so the cart shows the un-flagged lines */
          if (document.body.classList.contains('template-cart')) window.location.reload();
          else document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      })
      .catch(function () { clearing = false; });
  }

  document.addEventListener('click', function (e) {
    var rm = e.target.closest && e.target.closest('.remove, [href*="quantity=0"], [data-js-cart-remove]');
    if (!rm) return;
    var row = rm.closest('.cart-item__product-info') || rm.closest('[class*="cart-item"]');
    if (!isPrecutRow(row)) return;
    /* let the theme's own removal run, then strip the flags */
    setTimeout(clearPrecutFlags, 900);
  }, true);

  /* ---------- boot + re-apply after every cart re-render ---------- */
  function run() { try { lock(document); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  var t = null;
  new MutationObserver(function () {
    if (t) return;
    t = setTimeout(function () { t = null; run(); }, 150);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
